export default __webpack_public_path__ + "static/media/slot-icon.f78e6460.webp";